import * as actions from './types/actions';
import * as mutations from './types/mutations';
import ChapterService from './../../../services/chapter-service/ChapterService'
import {GET_ARTISTS} from "./types/actions";

export default {
    [actions.GET_ARTISTS]: async ({ commit, dispatch }, choice) => {
        try {
            const artists = await ChapterService.getArtists(choice);
            commit(mutations.SET_ARTISTS, artists);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.GET_CHAPTERS]: async ({ commit, dispatch }, audioBookId) => {
        try {
            const chapters = await ChapterService.getChaptersByAudioBookId(audioBookId);
            commit(mutations.SET_CHAPTERS, chapters);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.MIX_CHAPTERS]: async ({ commit, dispatch }, data) => {
        try {
            const chapters = await ChapterService.getMixedChapters(data);
            commit(mutations.SET_CHAPTERS, chapters);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.GET_CHAPTER]: async ({ commit, dispatch }, id) => {
        try {
            const chapter = await ChapterService.getChapterById(id);
            commit(mutations.SET_CHAPTER, chapter);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.ADD_CHAPTER]: async ({ commit, dispatch }, data) => {
        try {
            const chapter = await ChapterService.addChapter(data);
            commit(mutations.ADD_CHAPTER, chapter);
            return chapter;
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.UPDATE_CHAPTER]: async ({ commit, dispatch }, data) => {
        try {
            const chapter =  await ChapterService.updateChapter(data);
            commit(mutations.ADD_CHAPTER, chapter);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.UPDATE_CHAPTER_NAME]: async ({ commit, dispatch }, data) => {
        try {
            const chapter =  await ChapterService.updateChapterName(data);
            commit(mutations.ADD_CHAPTER, chapter);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.SET_SYNC_FOR_CURRENT_CHAPTER]: ({ commit, dispatch }, data) => {
        try {
            commit(mutations.SET_SYNC_FOR_CURRENT_CHAPTER, data);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.UPDATE_SYNC_FOR_CURRENT_CHAPTER]: ({ commit, dispatch }, data) => {
        try {
            commit(mutations.UPDATE_SYNC_FOR_CURRENT_CHAPTER, data);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.DELETE_SYNC_FOR_CURRENT_CHAPTER]: ({ commit, dispatch }, data) => {
        try {
            commit(mutations.DELETE_SYNC_FOR_CURRENT_CHAPTER, data);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.ADD_SYNC_FOR_CURRENT_CHAPTER]: async ({ commit, dispatch }, data) => {
        try {
            const chapter = await ChapterService.addTimestamps(data);
            commit(mutations.ADD_CHAPTER, chapter);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.ADD_AUDIO_FOR_CURRENT_CHAPTER]: async ({ commit, dispatch }, data) => {
        try {
            const chapter = await ChapterService.addAudio(data);
            commit(mutations.SET_CHAPTER, chapter);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.DELETE_AUDIO_FOR_CURRENT_CHAPTER]: async ({ commit, dispatch }, data) => {
        try {
            const chapter = await ChapterService.deleteAudio(data);
            commit(mutations.SET_CHAPTER, chapter);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.DELETE_CHAPTER]: async ({ commit, dispatch }, id) => {
        try {
            await ChapterService.delete(id);
            commit(mutations.DELETE_CHAPTER, id);
        } catch (error) {
            dispatch(error);
        }
    }
};
